import { render } from "./TableLiteCurrency.vue?vue&type=template&id=58f4e19f&scoped=true"
import script from "./TableLiteCurrency.vue?vue&type=script&lang=js"
export * from "./TableLiteCurrency.vue?vue&type=script&lang=js"

import "./TableLiteCurrency.vue?vue&type=style&index=0&id=58f4e19f&scoped=true&lang=css"

import exportComponent from "/home/douglas/Documents/Rwi/surefooted-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f4e19f"]])

export default __exports__